






























































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderPayDoneGrids from '@/components/order/mixins/OrderPayDoneGrids';

import { Component, Mixins, Ref } from 'vue-property-decorator';
import {PutOrderOptionChangeStatusRequest} from 'supporter';
import {ncpPopup} from '@/utils/commonUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable}
})
export default class OrderListPayDone extends Mixins(OrderPayDoneGrids, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom')
  private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private request: any = {
    params: {}
  };
  public ifExchange: boolean = false;
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private memberGroupData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };

  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };
  private created(): void {}
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on(
        'click',
        '#exchangeHelpBtn',
        $.proxy(() => {
          this.ifExchange = true;
        }, this)
    );
  }


  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').off(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
  }

  // LINK: src/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue
  protected changeOrderStatus(items) {
    const options = items.map(item => ({
	    deliveryCompanyType: item.deliveryCompanyType,
	    invoiceNo: item.invoiceNo,
	    mallNo: item.mallNo,
	    orderOptionNo: item.orderProductOptionNo,
    }));

    const request: PutOrderOptionChangeStatusRequest = {
      data: {
        orderStatusType: 'PRODUCT_PREPARE',
        options
      }
    };

    this.$api.putOrderOptionChangeStatus(request).then(() => {
      this.search(1, this.size);
    });
  }

  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse(
      $(e.target)
        .data('json')
        .replace(/\\\"/g, '"')
    );
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }
  public initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_paid_';
  }
  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'PAY_DONE';
    this.request.params.partnerNo = Number(e.partnerNo);

    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then(res => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private handleCancel(): void {}
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'PAY_DONE';
    this.request.params.page = page;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then(res => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo',
            'lastSubPayAmt',
            'lastMainPayAmt',];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt',
          ];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private getCheckedItems(arr: any): any {
    return (this.$refs.gridBottom as any).getCheckedItems(arr);
  }
  private handlePut(): void {
    const theOption = this.getCheckedItems(['invoiceNo', 'deliveryCompanyType', 'mallNo', 'orderProductOptionNo']);
    if (theOption && theOption.length > 0) {
      if (confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE') as string)) {
        let requestOp: any = theOption.map((item: any) => {
          return {deliveryCompanyType: item.deliveryCompanyType, invoiceNo: item.invoiceNo, mallNo: item.mallNo, orderOptionNo: item.orderProductOptionNo};
        });
        let request: PutOrderOptionChangeStatusRequest = {
          data: {
            orderStatusType: 'PRODUCT_PREPARE',
            options: requestOp
          }
        };
        this.$api.putOrderOptionChangeStatus(request).then(() => {
          alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
          this.search(1, this.size);
        });
      }
    } else {
      alert(this.$t('ORDER_LIST_GRIDS_PAY_DONE_NOT_CHECK_ROW_ALERT'));
    }
  }
}
